import React from 'react';
import { cardTheme } from '../../styles/cardTheme';

interface HomeSectionCardProps {
  id?: string;
  children: React.ReactNode;
  className?: string;
  innerClassName?: string;
  overflowVisible?: boolean;
}

const HomeSectionCard: React.FC<HomeSectionCardProps> = ({
  id,
  children,
  className = '',
  innerClassName = 'p-6 sm:p-8 lg:p-10',
  overflowVisible = false,
}) => (
  <section
    id={id}
    className={`${cardTheme.shell} ${cardTheme.shellHover} ${overflowVisible ? '!overflow-visible' : ''} ${className}`}
  >
    <div className={`${cardTheme.accentTop} ${innerClassName} ${overflowVisible ? 'overflow-visible' : ''}`}>
      {children}
    </div>
  </section>
);

export default HomeSectionCard;
